
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"49","height":"29","rx":"1.5","stroke":"#fff"}}),_c('path',{attrs:{"d":"M14.374 10.123c.397-.496.667-1.163.596-1.845-.582.03-1.291.384-1.702.881-.369.426-.695 1.12-.61 1.773.653.057 1.305-.326 1.716-.809zM14.963 11.06c-.948-.056-1.753.538-2.206.538-.453 0-1.146-.51-1.895-.496-.976.014-1.881.566-2.376 1.443-1.019 1.756-.27 4.36.721 5.789.481.707 1.06 1.485 1.824 1.457.722-.028 1.005-.467 1.882-.467.876 0 1.13.467 1.895.453.792-.014 1.287-.707 1.768-1.415.551-.806.777-1.585.791-1.627-.014-.015-1.527-.595-1.54-2.336-.015-1.457 1.187-2.15 1.244-2.193-.68-1.004-1.74-1.118-2.108-1.146zM24.414 9.088c2.06 0 3.494 1.42 3.494 3.487 0 2.074-1.464 3.502-3.546 3.502h-2.28v3.626h-1.648V9.088h3.98zm-2.333 5.606h1.891c1.435 0 2.251-.773 2.251-2.112s-.816-2.104-2.243-2.104H22.08v4.216zM28.316 17.504c0-1.361 1.038-2.141 2.95-2.259l2.053-.125v-.588c0-.861-.567-1.332-1.574-1.332-.832 0-1.435.427-1.56 1.082h-1.486c.044-1.376 1.339-2.377 3.09-2.377 1.883 0 3.111.986 3.111 2.516v5.282h-1.522v-1.272h-.037c-.434.831-1.39 1.353-2.428 1.353-1.53 0-2.597-.912-2.597-2.28zm5.003-.684v-.596l-1.832.117c-1.03.067-1.567.45-1.567 1.119 0 .647.56 1.066 1.435 1.066 1.118 0 1.964-.713 1.964-1.706zM36.3 22.543V21.27c.103.015.353.03.486.03.728 0 1.14-.309 1.39-1.104l.147-.47L35.535 12h1.722l1.942 6.268h.037L41.178 12h1.677l-2.891 8.114c-.662 1.862-1.42 2.472-3.024 2.472-.125 0-.53-.014-.64-.044z","fill":"#ADADAD"}})])
          )
        }
      }
    